// removed by extract-text-webpack-plugin
module.exports = {"cwShellLeftNav":"CwShellLeftNav-cwShellLeftNav","collapsed":"CwShellLeftNav-collapsed","default":"CwShellLeftNav-default","fat":"CwShellLeftNav-fat","cwShellLeftNavContainer":"CwShellLeftNav-cwShellLeftNavContainer","expansionIconContainer":"CwShellLeftNav-expansionIconContainer","expansionIcon":"CwShellLeftNav-expansionIcon","collapseIcon":"CwShellLeftNav-collapseIcon","expandIcon":"CwShellLeftNav-expandIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshellleftnav/CwShellLeftNav.scss
// module id = 386
// module chunks = 0